<template>
  <el-dialog
    title="申请退款"
    :visible.sync="dialogVisible"
    width="500px"
    @close="handleClose"
  >
    <el-form
      ref="refundForm"
      :model="formData"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item label="订单号">
        <el-input v-model="formData.order_no" disabled />
      </el-form-item>

      <el-form-item label="套餐名称">
        <el-input v-model="formData.package_name" disabled />
      </el-form-item>

      <el-form-item label="订单金额">
        <el-input v-model="formData.order_amount" disabled>
          <template slot="prepend">¥</template>
        </el-input>
      </el-form-item>

      <el-form-item label="退款金额" prop="refund_amount">
        <el-input-number
          v-model="formData.refund_amount"
          :precision="2"
          :step="0.01"
          :min="0.01"
          :max="parseFloat(formData.order_amount)"
          controls-position="right"
          style="width: 100%"
        />
        <div style="margin-top: 5px; font-size: 12px; color: #909399">
          最多可退款：¥{{ formData.order_amount }}
        </div>
      </el-form-item>

      <el-form-item label="退款原因" prop="refund_reason">
        <el-input
          v-model="formData.refund_reason"
          type="textarea"
          :rows="4"
          placeholder="请详细说明退款原因"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>

      <el-alert
        title="退款说明"
        type="warning"
        :closable="false"
        style="margin-top: 10px"
      >
        <div style="font-size: 12px; line-height: 1.8">
          1. 退款申请提交后需要主管审批<br>
          2. 审批通过后将自动调用富友支付退款<br>
          3. 如订单已产生佣金，退款成功后将自动扣减<br>
          4. 支持360天内退款
        </div>
      </el-alert>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="danger" :loading="submitLoading" @click="handleSubmit">
        提交退款申请
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { createRefund } from '@/api/iccid-refund'

export default {
  name: 'RefundApplyDialog',
  data() {
    const validateRefundAmount = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('退款金额必须大于0'))
      } else if (value > parseFloat(this.formData.order_amount)) {
        callback(new Error('退款金额不能超过订单金额'))
      } else {
        callback()
      }
    }

    return {
      dialogVisible: false,
      submitLoading: false,
      formData: {
        order_no: '',
        package_name: '',
        order_amount: '',
        refund_amount: 0,
        refund_reason: ''
      },
      rules: {
        refund_amount: [
          { required: true, message: '请输入退款金额', trigger: 'blur' },
          { validator: validateRefundAmount, trigger: 'blur' }
        ],
        refund_reason: [
          { required: true, message: '请输入退款原因', trigger: 'blur' },
          { min: 5, message: '退款原因至少5个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(orderData) {
      this.dialogVisible = true
      this.formData = {
        order_no: orderData.order_no,
        package_name: orderData.package_name,
        order_amount: parseFloat(orderData.price).toFixed(2),
        refund_amount: parseFloat(orderData.price),
        refund_reason: ''
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs.refundForm.resetFields()
    },
    async handleSubmit() {
      this.$refs.refundForm.validate(async valid => {
        if (!valid) return

        this.submitLoading = true
        try {
          const { data } = await createRefund({
            order_no: this.formData.order_no,
            refund_amount: this.formData.refund_amount,
            refund_reason: this.formData.refund_reason
          })

          this.$message.success('退款申请已提交，请等待审批')
          this.handleClose()
          this.$emit('success', data)
        } catch (error) {
          this.$message.error(error.message || '提交失败')
        } finally {
          this.submitLoading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
